import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationsKeys } from "web_myplann/Api/Notifications/notificatioKeys";
import { patchNotificationsReadAllV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useNotificationMarkAllAsReadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((filterLastnotificationid: number) =>
			patchNotificationsReadAllV2(filterLastnotificationid),
		),
		onMutate: async () => {
			await Promise.all([
				queryClient.cancelQueries({
					queryKey: NotificationsKeys.infiniteGroupedList(true),
				}),
				queryClient.cancelQueries({ queryKey: NotificationsKeys.count() }),
			]);
		},
		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: NotificationsKeys.infiniteGroupedList(true),
			});
			queryClient.invalidateQueries({
				queryKey: NotificationsKeys.infiniteGroupedList(false),
			});
			queryClient.invalidateQueries({ queryKey: NotificationsKeys.count() });
		},
	});
};
